// extracted by mini-css-extract-plugin
export default {"label":"_2jkOsTI1SwlAZIfP-0N4WL","disabled":"_1Z0VWigzkQyAdwHDe16K6U"};